import React from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import Message from '../layout/Message';
import Button from '../layout/Button';
import FormField from '../layout/FormField';
import DataTable from 'react-data-table-component';

import {
    fetchPianoTechnicianList,
    RETURN_TO_PIANOTECHNICIAN_LIST,
    SWITCH_EDIT_TYPE_PIANOTECHNICIAN,
    PIANOTECHNICIAN_MODIFIED,
    SAVE_PIANOTECHNICIAN_STARTED,
    savePianoTechnician,
    PIANOTECHNICIAN_VALIDATE,
    fetchPianoTechnicianListForCompany,
} from '../../actions/PianoTechnicianActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_EDIT,
    MAINTENANCE_TYPE_ADD,
    MAINTENANCE_TYPE_COMPLETE,
    MAINTENANCE_TYPE_DELETE,
    uiFieldInfoPianoTechnician,
    MESSAGE_TYPE_INFO,
    MESSAGE_TYPE_ERROR,
    defaultTravelTimes,
    defaultAppointmentTimes,
    timeZones,
} from '../../app-constants';

import {
    validateForm,
    checkForChanges,
} from '../../utilities/validate';

const mapStateToProps = state => ({
    pianoTechnician: state.pianoTechnician,
    pianoTechCompany: state.pianoTechCompany,
    pianoTechAppointment: state.pianoTechAppointment,
    user: state.user,
});

class PianoTechnician extends React.PureComponent {

    returnToList = () => {

        if (this.props.pianoTechnician.maintenanceType === MAINTENANCE_TYPE_COMPLETE) {
            const { adminUser, simulatingUser } = this.props.user;

            if (adminUser && !simulatingUser) {
                if (!this.props.pianoTechnician.pianoTechnicianList || this.props.pianoTechnician.pianoTechnicianList.length === 0)
                    this.props.dispatch(fetchPianoTechnicianList());
            } else {
                const { pianoTechCompany } = this.props.pianoTechCompany;
                if (!this.props.pianoTechnician.pianoTechnicianList || this.props.pianoTechnician.pianoTechnicianList.length === 0)
                    this.props.dispatch(fetchPianoTechnicianListForCompany(pianoTechCompany.companyId));
            }
        }

        this.props.dispatch({
            type: RETURN_TO_PIANOTECHNICIAN_LIST
        })
    }

    onCancelClose = () => {

        switch (this.props.pianoTechnician.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
            case MAINTENANCE_TYPE_EDIT: {
                //Back to View Mode - restore original 
                const pianoTechnician = Object.assign({}, this.props.pianoTechnician.originalPianoTechnician);
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE_PIANOTECHNICIAN,
                    maintenanceType: MAINTENANCE_TYPE_VIEW,
                    title: "View PianoTechnician",
                    pianoTechnician,
                });

                break;
            }

            default:
                this.returnToList();
        }
    }

    editPianoTechnician = () => {
        const pianoTechnician = this.props.pianoTechnician.pianoTechnician;
        this.props.dispatch({
            type: SWITCH_EDIT_TYPE_PIANOTECHNICIAN,
            maintenanceType: MAINTENANCE_TYPE_EDIT,
            title: "Edit PianoTechnician",
            pianoTechnician,
        });
    }

    onDelete = () => {
        switch (this.props.pianoTechnician.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                this.saveAction();
                break;

            default:
                const pianoTechnician = this.props.pianoTechnician.pianoTechnician;
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE_PIANOTECHNICIAN,
                    maintenanceType: MAINTENANCE_TYPE_DELETE,
                    title: "Delete PianoTechnician",
                    pianoTechnician,
                });
        }
    }

    saveAction = () => {
        let message = '';

        switch (this.props.pianoTechnician.maintenanceType) {
            case MAINTENANCE_TYPE_EDIT:
                message = 'Saving PianoTechnician';
                break;
            case MAINTENANCE_TYPE_DELETE:
                message = 'Deleting PianoTechnician';
                break;
            case MAINTENANCE_TYPE_ADD:
                message = 'Adding PianoTechnician';
                break;

            default:

        }

        this.props.dispatch({
            type: SAVE_PIANOTECHNICIAN_STARTED,
            message,
        })

        const { adminUser, simulatingUser } = this.props.user;

        let returnUpdateList = 'Y';

        if (adminUser && !simulatingUser) {
            returnUpdateList = 'N';
        }

        const { pianoTechnician } = this.props.pianoTechnician;
        pianoTechnician.maintenanceType = this.props.pianoTechnician.maintenanceType;
        this.props.dispatch(savePianoTechnician(pianoTechnician, returnUpdateList));
    }

    onChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { pianoTechnician } = this.props.pianoTechnician;
        pianoTechnician[fieldName] = fieldValue;

        this.props.dispatch({
            type: PIANOTECHNICIAN_MODIFIED,
            pianoTechnician,
        })

    }

    formValid = () => {
        const { pianoTechnician, maintenanceType } = this.props.pianoTechnician;
        const validFormInfo = validateForm(uiFieldInfoPianoTechnician, pianoTechnician, maintenanceType);

        return validFormInfo.valid;
    }

    validate = () => {
        const { pianoTechnician, maintenanceType } = this.props.pianoTechnician;
        const validInfo = validateForm(uiFieldInfoPianoTechnician, pianoTechnician, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHNICIAN_VALIDATE,
            message,
            messageType,
        })
    }

    checkForChanges = () => {
        const { pianoTechnician, originalPianoTechnician, maintenanceType } = this.props.pianoTechnician

        if (!this.formValid())
            return false;

        if (maintenanceType === 'add') {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechnician, pianoTechnician, originalPianoTechnician)

    }

    render() {

        const appointmentColumns = [
            {
                name: 'Appointment Id',
                selector: row => row.appointmentId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Piano Id',
                selector: row => row.pianoId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Technician Name',
                selector: row => row.technicianName,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Service Reason',
                selector: row => row.serviceReason,
                sortable: true,
                width: '30%',
            },
            {
                name: 'Tech Start Time',
                selector: row => row.appointmentTimeStart,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Tech End Time',
                selector: row => row.appointmentTimeEnd,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Cust Start Time',
                selector: row => row.customerAppointmentTimeStart,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Cust End Time',
                selector: row => row.customerAppointmentTimeEnd,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Minutes Required',
                selector: row => row.minutesRequired,
                sortable: true,
                width: '10%',
            },
        ]

        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        const { pianoTechnician, maintenanceType } = this.props.pianoTechnician;
        const { adminUser, simulatingUser } = this.props.user;
        const { appointmentsFromDate, appointmentUpdateComplete } = this.props.pianoTechAppointment;

        let showSave = false, showDelete = false, cancelCloseText = 'Cancel', showEdit = false,
            disabled = false, disableSave = false, deleteText = 'Delete';

        let displayAppointments = [];

        if (appointmentsFromDate && appointmentsFromDate.length > 0) {
            displayAppointments = appointmentsFromDate.filter(appointment => appointment.techniciansId === pianoTechnician.techniciansId);
        }

        switch (this.props.pianoTechnician.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                showDelete = true;
                disabled = true;
                deleteText = 'Confirm Delete';
                break;

            case MAINTENANCE_TYPE_COMPLETE:
                showSave = false;
                cancelCloseText = 'Close';
                disabled = true;
                break;

            case MAINTENANCE_TYPE_VIEW:
                showEdit = this.props.user.allowEdit;
                showDelete = this.props.user.allowDelete;
                disabled = true;
                cancelCloseText = 'Close';
                break;

            default:
                if (this.props.user.allowEdit)
                    showSave = true;

                disableSave = !this.checkForChanges();
        }

        return (
            <div className="divMedium" align="center">
                <Header header2={this.props.pianoTechnician.title} />
                <Message message={this.props.pianoTechnician.message}
                    type={this.props.pianoTechnician.messageType} />
                <br />
                <table className='tableMedium'>
                    <tbody>
                        <tr>
                            <td>
                                <Button className="bluebutton2" description="Return to List" onClick={this.returnToList} />
                            </td>
                            <td>
                            </td>
                        </tr>
                        {maintenanceType !== MAINTENANCE_TYPE_ADD &&
                            <FormField row form={{ title: 'Technicians Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                name="techniciansId"
                                value={pianoTechnician.techniciansId}
                                onChange={this.onChange}
                            />
                        }
                        {adminUser && !simulatingUser &&
                            <FormField row form={{ title: 'Company Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                name="companyId"
                                value={pianoTechnician.companyId}
                                onChange={this.onChange}
                            />
                        }
                        <FormField row form={{ title: 'Technician Name', type: 'textinput', length: '80', maxLength: '80', disabled }}
                            name="technicianName"
                            value={pianoTechnician.technicianName}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Address Line 1', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="addressLine1"
                            value={pianoTechnician.addressLine1}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Address Line 2', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="addressLine2"
                            value={pianoTechnician.addressLine2}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'City', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="city"
                            value={pianoTechnician.city}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'State', type: 'textinput', length: '20', maxLength: '20', disabled }}
                            name="state"
                            value={pianoTechnician.state}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Country', type: 'textinput', length: '50', maxLength: '50', disabled }}
                            name="country"
                            value={pianoTechnician.country}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Email', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="email"
                            value={pianoTechnician.email}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Phone', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="encryptedPhone"
                            value={pianoTechnician.encryptedPhone}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Tax Id', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="encryptedTaxId"
                            value={pianoTechnician.encryptedTaxId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Default Minutes Per Appointment (-1)', type: 'select', options: defaultAppointmentTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled }}
                            name="defaultMinutesPerAppointment"
                            value={pianoTechnician.defaultMinutesPerAppointment}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Default Travel Time Before Appointment Minutes (-1)', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled }}
                            name="defaultBeforeAppointmentMinutes"
                            value={pianoTechnician.defaultBeforeAppointmentMinutes}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Default Travel Time After Appointment Minutes (-1)', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled }}
                            name="defaultAfterAppointmentMinutes"
                            value={pianoTechnician.defaultAfterAppointmentMinutes}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'OnlyScheduleWithinNormalScheduled', type: 'checkbox', disabled }}
                            name="onlyScheduleWithinNormalScheduled"
                            value={pianoTechnician.onlyScheduleWithinNormalScheduled}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Time Zone', type: 'select', options: timeZones, optionTitle: 'description', optionValue: 'minutesFromUTC', disabled }}
                            name="utcHoursAdjustment"
                            value={pianoTechnician.utcHoursAdjustment}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'MondayStartTime', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="mondayStartTime"
                            value={pianoTechnician.mondayStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Monday Sop Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="mondayStopTime"
                            value={pianoTechnician.mondayStopTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Tuesday Start Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="tuesdayStartTime"
                            value={pianoTechnician.tuesdayStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Tuesday Stop Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="tuesdayStopTime"
                            value={pianoTechnician.tuesdayStopTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Wednesday Start Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="wednesdayStartTime"
                            value={pianoTechnician.wednesdayStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Wednesday Stop Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="wednesdayStopTime"
                            value={pianoTechnician.wednesdayStopTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Thursday Start Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="thursdayStartTime"
                            value={pianoTechnician.thursdayStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Thursday Stop Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="thursdayStopTime"
                            value={pianoTechnician.thursdayStopTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Friday Start Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="fridayStartTime"
                            value={pianoTechnician.fridayStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Friday Stop Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="fridayStopTime"
                            value={pianoTechnician.fridayStopTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Saturday Start Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="saturdayStartTime"
                            value={pianoTechnician.saturdayStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Saturday Stop Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="saturdayStopTime"
                            value={pianoTechnician.saturdayStopTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Sunday Start Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="sundayStartTime"
                            value={pianoTechnician.sundayStartTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Sunday Stop Time', type: 'textinput', length: '4', maxLength: '4', disabled }}
                            name="sundayStopTime"
                            value={pianoTechnician.sundayStopTime}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Created', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="created"
                            value={pianoTechnician.created}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Updated', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="lastUpdated"
                            value={pianoTechnician.lastUpdated}
                            onChange={this.onChange}
                        />
                        <tr>
                            <td>
                                {showEdit &&
                                    <Button className="bluebutton" description="Edit" onClick={this.editPianoTechnician} />
                                }
                                {showDelete &&
                                    <Button className="bluebutton2" description={deleteText} onClick={this.onDelete} />
                                }
                                {showSave &&
                                    <div>
                                        <Button className="bluebutton" description="Save" disabled={disableSave} onClick={this.saveAction} />
                                        <Button className="bluebutton2" description="Validate" onClick={this.validate} />
                                    </div>
                                }
                            </td>
                            <td>
                                <Button className="bluebutton2" description={cancelCloseText} onClick={this.onCancelClose} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <DataTable
                    title={`UpcomingAppointments`}
                    className='app-table'
                    columns={appointmentColumns}
                    customStyles={customStyles}
                    striped
                    data={displayAppointments}
                    defaultSortField="appointmentDate"
                    highlightOnHover
                    pagination
                />
            </div>
        )
    }

}

export default connect(mapStateToProps)(PianoTechnician);
